module.exports = __webpack_public_path__ + "76f553c6847b7bb941a16b3c77ee73e5.svg";